<template>
  <div class="update-drawer">
    <div class="backdrop" @click="() => $emit('close')" />
    <div class="update-drawer-content">
      <div class="header-container">
        <FriedH3>{{ t('dr_updates_title') }}</FriedH3>
        <FriedIconButton data-external="dr-updates-drawer-close-button" @click="$emit('close')">
          <FriedIcon :size="IconSize.Small" icon="close" />
        </FriedIconButton>
      </div>
      <div class="feed-container">
        <Feed
          :participants="participants"
          :owner="owner"
          :participant-id="participantId"
          @show-post-details-modal="showPostDetailsModal = $event"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, onMounted, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { IconSize } from '@getaccept/fried-tofu';
import type { Participant } from '@getaccept/dsr-shared-new';
import Feed from '../feed/components/Feed.vue';

export default defineComponent({
  components: {
    Feed,
  },
  props: {
    participants: {
      type: Array as PropType<Participant[]>,
      default: () => [],
    },
    owner: {
      type: Object as PropType<Participant>,
      default: () => ({} as Participant),
    },
    participantId: {
      type: String,
      required: true,
    },
  },
  setup(_, { emit }) {
    const { t } = useI18n();
    const showPostDetailsModal = ref(false);

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !showPostDetailsModal.value) {
        emit('close');
      }
    };

    onMounted(() => {
      window.addEventListener('keydown', handleKeyDown);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('keydown', handleKeyDown);
    });

    return {
      t,
      IconSize,
      showPostDetailsModal,
      handleKeyDown,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/dsr-shared-new/src/scss/update-drawer';
</style>
